import React, { useState } from "react";
// import PropTypes from "prop-types";
import "./../../components/LoginForm/LoginForm.scss";
import { Input } from "../../common/Input/Input";
import { Button } from "../../common/Button/Button";
import logo from "./../../assets/logo.png";
import api from "../../utils/api";
import { toast } from "react-toastify";

export default function ForgotPassword(props) {
  const [email, handleInputChange] = useState('');
  const requestPasswordLink = () => {
    api.requestResetPassword({ email }).then(() => {
      toast('Reset password link is sent to your email.',
        { autoClose: 5000, type: toast.TYPE.SUCCESS });
    })
  }
  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form">
          <div className="text-center mt10 mb20">
            <img
              alt="deasra-logo"
              src={logo}
              className="h40 mb20 logo-img"
            />
          </div>
          <div className="text-help">Please enter your email address.</div>
          <Input
            className="email"
            name="email"
            type="email"
            placeholder="Email"
            onChange={({ target: { name, value } }) => handleInputChange(value)}
          />
          {props.error ? (
            <div className="form-error mt10">{props.error}</div>
          ) : null}
          <div className="flex justify-content-stretch mt20 mb20">
            <Button
              className="w100p pt10 pb10"
              primary
              onClick={requestPasswordLink}
            >
              Send Reset Link
            </Button>
          </div>
          <div className="flex justify-content-center mt20">
            Go to
            <a
              href="/login"
              className="ml10 text-link cursor-pointer"
            >
              Login
              </a>
          </div>
        </div>
      </div>
    </div>
  );
}
